import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Spin } from 'antd';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import Helpers from '@Apis/helpers';
import dayjs from 'dayjs';

function MetricBarLineChart({
  data, loading, title, selectedTenant, fromDate, toDate, MONEY, columnTitle, lineTitle, columnDataKey, lineDataKey, dateKey, chartSize,
}) {
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  // Prepare series data for ApexCharts
  const labels = data.map((sale) => (dateKey ? dayjs(sale[dateKey]).format('D MMM YY') : dayjs(sale.sale_date).format('D MMM YY')));
  const seriesData = [
    { name: `${columnTitle || 'Sales'}`, type: 'column', data: data.map((sale) => parseInt(columnDataKey ? sale[columnDataKey] : sale.total_sales)) },
    { name: `${lineTitle || 'Orders'}`, type: 'line', data: data.map((sale) => parseInt(lineDataKey ? sale[lineDataKey] : sale.total_invoice_count)) },
  ];

  const handleSegmentClick = (event, chartContext, config) => {
    // const department = departments[config.dataPointIndex];
    // const status = statuses[config.seriesIndex].replaceAll(' ', '_').toUpperCase();
    // const departmentId = data?.find((item) => item.department === department)?.department_id;

    // const url = `/purchase/purchase-request?page=1&limit=10&tenant=${selectedTenant}&status=${status}&department_ids=${departmentId}&from_date=${dayjs(fromDate).format('YYYY-MM-DD')}&to_date=${dayjs(toDate).format('YYYY-MM-DD')}`;
    // window.open(url, '_blank');
  };

  const chartOptions = {
    chart: {
      type: 'line',
      height: 450,
      toolbar: {
        show: true,
      },
      events: {
        dataPointSelection: handleSegmentClick,
      },
    },
    stroke: {
      width: [0, 2],
      curve: 'straight',
    },
    labels,
    xaxis: {
      type: 'date',
      labels: {
        datetimeFormatter: {
          day: 'dd MMM yy',
        },
      },
      crosshairs: {
        show: false,
      },
    },
    yaxis: [{
      title: {
        text: `${columnTitle || 'Sales'}`,
      },
      labels: {
        formatter: (value) => MONEY(value).split('.')[0],
      },
    }, {
      opposite: true,
      title: {
        text: `${lineTitle || 'Orders'}`,
      },
    }],
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
    },
    tooltip: {
      intersect: false,
      shared: true,
      inverseOrder: true,
    },
  };

  return (
    <div className="metric-bar-line-bar__loader">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-bar-line-bar">
        <H3Text text={title} className="metric-bar-line-bar__title" />
        <div className="metric-bar-line-bar__content">
          <div className="metric-bar-line-bar__chart">
            <ReactApexChart options={chartOptions} series={seriesData} height={chartSize || 250} />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({});

MetricBarLineChart.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  title: PropTypes.string,
  selectedTenant: PropTypes.string,
  fromDate: PropTypes.any,
  toDate: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricBarLineChart));
